<template>
    <div class="game-page">
        <!-- 游戏主iframe -->
        <iframe ref="gameframe" class="game-iframe" :src="url" frameborder="0" @load="onLoad" />

        <!-- 个人中心 / 支付弹窗 -->
        <van-popup v-model:show="popShow" round :style="{ height: '90%', width: '90%', maxWidth: '580px', zIndex: 9999 }">
            <iframe class="pop-iframe" :src="popUrl" frameborder="0" />
        </van-popup>

        <!-- 悬浮球菜单弹窗 -->
        <van-popup v-model:show="menuShow" position="left" :style="{ width: '50%', maxWidth: '580px', height: '100%' }">
            <div class="menu-container">
                <div class="menu-tabs">
                    <div class="menu-tab" @click="onTabClick('home')">
                      <van-icon name="wap-home-o" class="tab-icon"/>
                        <span class="tab-text">主页</span>
                    </div>
                    <div class="menu-tab" @click="onTabClick('user')">
                      <van-icon name="user-o" class="tab-icon" />
                        <span class="tab-text">用户中心</span>
                    </div>
                </div>
                <div class="menu-footer">
                    <van-button round block color="#6e87ea" @click="onTabClick('switch')">切换账号</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 悬浮球 -->
        <float-ball v-if="showDragBall" @click="onDragBallClick" />
    </div>

    <!-- 登录全屏界面 -->
    <div class="full-image-page" v-if="showFullImg">
        <img :src="gameFullImg" alt="" class="full-img" />
    </div>

    <!-- 游戏全屏加载界面 -->
    <div class="game-loading" :class="{ fadeOut: !showLoading }">
        <div class="loading-container">
            <!-- 图标区域（带呼吸光晕） -->

            <div class="icon-wrapper">
                <div class="icon-bg"></div>
                <img v-if="gameIconImg" class="game-icon" :src="gameIconImg">
            </div>

            <!-- 加载标题 -->
            <div class="loading-title">游戏载入中</div>

            <!-- 圆点加载动画 -->
            <div class="dots-loader">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>


</template>

<script>
import { reactive, onMounted, ref, toRefs, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { Toast } from 'vant'
import { playGameInfo } from "@/service/web";
import { requestPayMode } from '@/service/pay'
import { weblogin, reqestDevice, reqestUpdateRole } from "@/service/game";
import { GLOBAL } from '@/configs/global'
import * as system from '@/utils/system'
import Fingerprint2 from 'fingerprintjs2'
import { validatenull } from '@/utils/validate'
import FloatBall from '@/components/FloatBall.vue'

export default {
    components: {
        FloatBall
    },
    setup() {
        const store = useStore()
        const route = useRoute()
        const gameframe = ref(null)

        const state = reactive({
            // 盒子ID
            boxId: 0,
            // SDK游戏ID
            gameId: 0,
            // 游戏信息
            gameInfo: {},
            gameFullImg: '',
            gameIconImg: '',
            
            url: '',
            popUrl: '',
            popShow: false,
            showLoading: false,
            showFullImg: false,
            isFirstRoleUpdate: true,
            showDragBall: false,
            menuShow: false,
            activeTab: ''
        })

        // 登录成功刷新游戏
        const onLoginSuccess = () => {
            state.url = ''
            init()
        }

        // 不登录的情况下回到主页
        const onCloseLogin = () => {
            window.location.href = window.location.origin
        }

        let handleBack = null
        const initBackInterceptor = () => {
            // console.log('initBackInterceptor', window.history.state)
            // // 初始化：用 replaceState 覆盖当前记录，确保每次返回都能触发 popstate
            // history.pushState(null, null, location.href)

            // handleBack = () => {
            //     history.pushState(null, null, location.href)

            //     Dialog.confirm({
            //         title: '退出游戏',
            //         message: '确定要退出游戏吗？',
            //         confirmButtonText: '确定退出',
            //         cancelButtonText: '继续游戏',
            //         confirmButtonColor: '#6387ea',
            //     }).then(() => {
            //         // 退出时清理监听，允许真实返回
            //         window.removeEventListener('popstate', handleBack)
            //         window.location.href = window.location.origin
            //     }).catch(() => {
            //         // 取消后不做任何操作，历史记录已重置，下次返回继续触发
            //         console.log('继续游戏，保持拦截')
            //         setTimeout(() => {
            //             history.pushState(null, null, location.href)
            //         }, 100)
            //     })
            // }
            // window.addEventListener('popstate', handleBack)
        }

        // ================== 生命周期 ==================
        onMounted(async () => {
            const isLogin = store.getters.isLogin;
            if (isLogin) {
                state.showLoading = true;
            }
            state.boxId = parseInt(route.query.id)
            
            // Toast.loading({ message: 'loading', forbidClick: true })
            let result = await playGameInfo(state.boxId);
            state.gameId = result.gameId;
            state.gameInfo = result;
            state.gameFullImg = result.loadingImg;
            state.gameIconImg = result.iconImg;
            console.log(result)
            // Toast.clear();
            
            init();
            window.addEventListener('loginSuccess', onLoginSuccess)
            window.addEventListener('closeLogin', onCloseLogin);
        })

        onUnmounted(() => {
            window.removeEventListener('closeLogin', onCloseLogin)
            window.removeEventListener('loginSuccess', onLoginSuccess)
            window.removeEventListener('message', handleMessage)
            window.removeEventListener('popstate', handleBack) // 清理监听
        })

        // ================== 初始化游戏 ==================
        const init = async () => {
            const isLogin = store.getters.isLogin;
            if (!isLogin || isLogin == "false") {
                state.showLoading = false;
                state.showFullImg = true;
                store.commit("setNeedLogin", true)
                return;
            }
            
            state.showFullImg = false;
            initBackInterceptor();
            requestDeviceInfo();

            let url = state.gameInfo.url;
            // 协议统一
            if (window.location.protocol === 'https:') {
                url = url.replace('http:', 'https:')
            } else {
                url = url.replace('https:', 'http:')
            }
            state.url = url;

            window.removeEventListener('message', handleMessage)
            window.addEventListener('message', handleMessage)
        }

        // ================== 游戏消息 ==================
        const handleMessage = (event) => {
            const res = event.data || {}
            switch (res.msg) {
                case 'login':
                    gamelogin()
                    break
                case 'updateRole':
                    updateRole(res.params)
                    break;
                case 'userCenter':
                    openUserCenter(res.params || {})
                    break
                case 'payOrder':
                    pay(res.params)
                    break
                case 'hzsdkPay':
                    res.success && window.open(res.pay_url)
                    break
                case 'switchAccount':
                    state.showFullImg = true;
                    state.popShow = false;
                    state.menuShow = false;
                    store.dispatch('logout')
                    store.commit('setNeedLogin', true)
                    break
                case 'showToast':
                    Toast.loading({ message: res.params, forbidClick: true })
                    break
                case 'hideToast':
                    Toast.clear()
                    break
            }
        }

        // ================== 游戏相关 ==================
        const requestDeviceInfo = async () => {
            let deviceId = store.getters.deviceId;
            if (validatenull(deviceId)) {
                const components = await new Promise((resolve) => {
                    Fingerprint2.get((components) => {
                        resolve(components);
                    });
                });
                const values = components.map(function (component, index) {
                    if (index === 0) {
                        return component.value.replace(/\bNetType\/\w+\b/, '');
                    }
                    return component.value;
                });
                deviceId = Fingerprint2.x64hash128(values.join(''), 31);
                store.commit("setDeviceId", deviceId);
            }

            const localStorageKey = state.gameId + "_gamebox_gameDeviceId";
            const storedDeviceId = window.localStorage.getItem(localStorageKey);
            console.log(deviceId, storedDeviceId);
            if (storedDeviceId) {
                return;
            }

            reqestDevice({
                gameId: state.gameId,
                deviceId: deviceId,
                os: "1", // "1" for Android, "2" for iOS
                model: system.GetCurrentBrowser(),
                osVersion: system.GetOs(),
                appVersion: "1.0.0",
                channel: store.getters.channel,
                ssid: ""
            }).then(result => {
                if (result.gameDeviceId) {
                    window.localStorage.setItem(localStorageKey, result.gameDeviceId);
                }
            }).catch(error => {
                console.error('Device registration failed:', error);
            });
        }

        const gamelogin = async () => {
            console.log('gamelogin')
            Toast.loading({ message: '登录中', forbidClick: true })
            await weblogin({
                "os": store.getters.os,
                "osVersion": system.GetOs(),
                "model": system.GetCurrentBrowser(),
                "gameId": state.gameId,
                "channel": store.getters.channel,
                "locale": store.getters.lang
            });
            Toast.clear();
            console.log("box ============ loginSuccess ============")
            state.showDragBall = true
            sendMessage('loginSuccess', {
                userName: store.getters.username,
                uid: store.getters.userId,
                token: store.getters.token,
            })
        }

        // 更新角色信息（1秒内只发一次，信息相同则跳过）
        let lastUpdateRoleTime = 0;
        let lastRoleKey = '';
        const updateRole = (role) => {
            const now = Date.now();
            if (now - lastUpdateRoleTime < 1000) {
                return;
            }

            if (typeof(role) == 'string') {
                role = JSON.parse(role);
            }

            // 生成关键信息指纹，与上次相同则跳过
            const roleKey = `${role.serverId || role.server || ''}_${role.userRoleId || role.roleId || ''}_${role.userRoleLevel || role.roleLevel || 0}_${role.vipLevel || 0}`;
            if (roleKey === lastRoleKey) {
                return;
            }
            lastRoleKey = roleKey;
            lastUpdateRoleTime = now;

            const isRoleLogin = state.isFirstRoleUpdate ? 1 : 0;
            state.isFirstRoleUpdate = false;

            console.log(role);
            // {"isCreateRole":true,"action":"login_role","roleCreateTime":0,"uid":"1","username":"test1","serverId":1,"serverName":"霸业1服","userRoleName":"美丽风流[s25]","userRoleId":"1","userRoleBalance":0,"vipLevel":10,"userRoleLevel":173,"partyId":0,"partyName":"","gameRoleGender":"","gameRolePower":0,"partyRoleId":0,"partyRoleName":"","professionId":"","profession":"","friendlist":""}

            const params = {
                "gameId": state.gameId,
                "server": role.serverId || role.server || '',
                "roleId": role.userRoleId || role.roleId || 0,
                "rolename": role.userRoleName || role.roleName || '',
                "level": role.userRoleLevel || role.roleLevel || 0,
                "vip": role.vipLevel || 0,
                "isLogin": isRoleLogin,
                "channel": parseInt(store.getters.channel),
                "gameVersion": role.gameVersion || '1.0.0',
                "model": system.GetCurrentBrowser()
            };

            reqestUpdateRole(params).then(result => {
                console.log('updateRole success', result);
            }).catch(error => {
                console.error('updateRole failed:', error);
            });
        }

        // ================== 个人中心 ==================
        const openUserCenter = (data) => {
            state.popUrl =
                'https://sdk.nzsgz.com/hzsdk/userCenter/user' +
                '?gameId=' + state.gameId +
                '&gameName=' + '' +
                '&userName=' + store.getters.username +
                '&server=' + (data.serverId || data.server || '') +
                '&roleId=' + (data.userRoleId || data.roleId || '') +
                '&rolename=' + (data.userRoleName || data.roleName || '') +
                '&roleLevel=' + (data.userRoleLevel || data.roleLevel || 0) +
                '&vip=' + (data.vipLevel || '') +
                '&token=' + store.getters.token +
                '&userId=' + store.getters.userId +
                '&channel=' + store.getters.channel +
                '&lang=' + store.getters.lang +
                '&isHtml5=1' +
                '&params=' + (data.params || '') +
                '&time=' + Math.random()

            state.popUrl = encodeURI(state.popUrl)
            state.popShow = true
        }

        // ================== 支付 ==================
        const pay = async (data) => {
            Toast.loading({ message: '请求支付中', forbidClick: true })
            const result = await requestPayMode({
                gameId: state.gameId,
                level: data.userRoleLevel || data.roleLevel || 0,
                channel: store.getters.channel,
            })
            Toast.clear();

            console.log("box ============ pay ============")
            console.log(data);
            if (!data.userRoleId && !data.roleId) {
                Toast.fail("充值失败，请检查角色信息")
                return;
            }

            // data.orderNo 是quick的订单号
            // {
            //     "productCode": "21314406869267086285949913548921",
            //     "uid": "1",
            //     "username": "test1",
            //     "userRoleId": "1",
            //     "userRoleName": "美丽风流[s25]",
            //     "serverId": 1,
            //     "userServer": "1",
            //     "userLevel": 173,
            //     "cpOrderNo": "1776306189753_1",
            //     "amount": 9,
            //     "subject": "1000元寶",
            //     "desc": "1000元寶",
            //     "extrasParams": "1_1_1000",
            //     "goodsId": "com.idle.immortal.fun.legendary.rpg.destiny.king.games.10",
            //     "count": 1,
            //     "callbackUrl": "",
            //     "quantifier": "",
            //     "channelToken": "1078@@@28",
            //     "channelCode": "4897",
            //     "orderNo": "489720260416102322305023963",
            //     "quickOrder": {
            //         "status": true,
            //         "orderNo": "489720260416102322305023963",
            //         "channelOrder": ""
            //     }
            // }

            state.popUrl =
                'https://sdk.nzsgz.com/hzsdk/payCenter/pay' +
                '?gameId=' + state.gameId +
                '&server=' + (data.serverId || data.server || '') +
                '&roleId=' + (data.userRoleId || data.roleId || '') +
                '&rolename=' + (data.userRoleName || data.roleName || '') +
                '&level=' + (data.userLevel || data.roleLevel || 0) +
                '&amount=' + (data.amount || '') +
                '&productId=' + (data.goodsId || data.productId || '') +
                '&productName=' + (data.subject || data.productName || '') +
                '&productSdkName=' + (data.subject || data.productSdkName || '') +
                '&outOrderNo=' + (data.orderNo || data.outOrderNo || '') +
                '&mode=' + (result.mode || '') +
                '&token=' + store.getters.token +
                '&channel=' + store.getters.channel +
                '&discount=' + (result.discount || '') +
                '&points=' + (result.points || '') +
                '&isHtml5=1' +
                '&lang=' + store.getters.lang +
                '&currency=CNY' +
                '&time=' + Math.random()

            state.popUrl = encodeURI(state.popUrl)
            state.popShow = true
        }

        // 悬浮球点击事件
        const onDragBallClick = () => {
            state.menuShow = true
        }

        // 标签点击事件
        const onTabClick = (tab) => {
            state.activeTab = tab
            state.menuShow = false
            if (tab === 'home') {
                // 返回主页
                window.location.href = window.location.origin
            } else if (tab === 'user') {
                // 打开用户中心
                openUserCenter({})
            } else if (tab === 'switch') {
                // 切换账号
                state.showFullImg = true
                store.dispatch('logout')
                store.commit('setNeedLogin', true)
            }
        }

        // ================== 向游戏发送消息 ==================
        const sendMessage = (msg, params) => {
            if (!gameframe.value?.contentWindow) return
            gameframe.value.contentWindow.postMessage({ msg, params }, '*')
        }

        // iframe 加载完成
        const onLoad = () => {
            if (state.url == "") {
                return;
            }
            sendMessage('initGame', {
                deviceId: '', apiUrl: GLOBAL.API_URL, username: store.getters.username,
                uid: store.getters.userId, token: store.getters.token, gameId: state.gameId,
                channel: store.getters.channel, os: store.getters.os, osVersion: system.GetOs(),
                model: system.GetCurrentBrowser(), ssid: '', lang: store.getters.lang
            })
            setTimeout(() => {
                state.showLoading = false
            }, 1000)
        }

        return {
            ...toRefs(state),
            gameframe,
            onLoad,
            onDragBallClick,
            onTabClick,
        }
    },
}
</script>

<style lang="less" scoped>
.game-page {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    background: #282828;
    overflow: hidden;
    /* iOS 安全区域适配 */
    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
    // box-sizing: border-box;

    /* 👇 让 iframe 完美居中 */
    display: flex;
    align-items: center;
    justify-content: center;
}

.game-iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    background: #000;
}

.pop-iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
}

.full-image-page {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 999;
}

.full-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 等比放大填满屏幕，不变形 */
}

/* 悬浮球菜单样式 */
.menu-container {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
}

.menu-tabs {
    flex: 1;
    padding-top: 20px;
}

.menu-tab {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    border-bottom: 1px solid #f0f0f0;
}

.menu-tab:hover {
    background-color: #f5f5f5;
}

.menu-tab:active {
    background-color: #e8e8e8;
}

.tab-text {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin-left: 5px;
}

.menu-group {
    border-bottom: 1px solid #f0f0f0;
}

.menu-group .menu-tab {
    border-bottom: none;
}

.menu-sub-tab {
    display: flex;
    align-items: center;
    padding: 12px 24px 12px 40px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.menu-sub-tab:hover {
    background-color: #f5f5f5;
}

.menu-sub-tab:active {
    background-color: #e8e8e8;
}

.menu-footer {
    padding: 20px;
    border-top: 1px solid #f0f0f0;
}

.switch-btn {
    width: 100%;
    padding: 12px 0;
    background: #fff;
    border: 1px solid #dc3545;
    border-radius: 8px;
    color: #dc3545;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.switch-btn:hover {
    background: #dc3545;
    color: #fff;
}

.switch-btn:active {
    opacity: 0.9;
}

/* 全屏背景（渐变+毛玻璃质感） */
.game-loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    background: linear-gradient(135deg, #6e87ea 0%, #839af5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    opacity: 1;
    visibility: visible;
    transition: all 0.6s cubic-bezier(0.33, 1, 0.68, 1);

    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: radial-gradient(circle at center, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
        pointer-events: none;
    }
}


.game-loading.fadeOut {
    opacity: 0;
    visibility: hidden;
}

/* 内容容器 */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 32px;
    position: relative;
    z-index: 2;
}

/* 图标外层（带呼吸光晕动画） */
.icon-wrapper {
    position: relative;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.15);
        animation: iconPulse 2.5s ease-in-out infinite;
    }

    .game-icon {
        width: 70px; // ✅ 图标大小在这里改！
        height: 70px; // ✅ 图标大小在这里改！
        object-fit: contain;
        position: relative;
        border-radius: 12px;;
        z-index: 2;
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
    }
}

/* 图标呼吸动画 */
@keyframes iconPulse {
    0% {
        transform: scale(1);
        opacity: 0.6;
    }

    50% {
        transform: scale(1.2);
        opacity: 0.3;
    }

    100% {
        transform: scale(1);
        opacity: 0.6;
    }
}

/* 加载标题 */
.loading-title {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 400;
    letter-spacing: 2px;
}

/* 圆点加载动画（优化版流动效果） */
.dots-loader {
    display: flex;
    gap: 10px;
    align-items: center;
    height: 24px;

    span {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #ffffff;
        opacity: 0.5;
        animation: dotWave 1.2s ease-in-out infinite;
        box-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
    }

    // 错开动画延迟，形成波浪流动
    span:nth-child(1) {
        animation-delay: 0s;
    }

    span:nth-child(2) {
        animation-delay: 0.15s;
    }

    span:nth-child(3) {
        animation-delay: 0.3s;
    }

    span:nth-child(4) {
        animation-delay: 0.45s;
    }

    span:nth-child(5) {
        animation-delay: 0.6s;
    }

    span:nth-child(6) {
        animation-delay: 0.75s;
    }
}

/* 圆点波浪动画 */
@keyframes dotWave {

    0%,
    100% {
        transform: scale(0.7);
        opacity: 0.4;
    }

    50% {
        transform: scale(1.3);
        opacity: 1;
    }
}
</style>